import { __ } from '@wordpress/i18n';

export const HELP_TEXTS = {
	CONNECTION_SEQUENCE: __(
		'Set the order in which SMTP connections should be used to send emails. The connection that matches the "From Email" will be used first, starting with the lowest sequence number. If it fails, the connection with the next sequence number will be tried.',
		'suremails'
	),
	FORCE_FROM_EMAIL: __(
		'Enable this option to force all emails sent from your site to use the "From Email" specified in this connection, overriding any other "From Email" set by other plugins, themes, etc.',
		'suremails'
	),
	RETURN_PATH: __(
		'The Return Path is where bounce messages (failed delivery notices) are sent. If it’s off, you might not get these messages. Turn it on to receive bounce notifications at the "From Email" address if delivery fails.',
		'suremails'
	),
	FORCE_FROM_NAME: __(
		'Enable this option to ensure all emails sent from your site use the "From Name" specified in this connection, overriding any other "From Name" set by other plugins, themes, etc.',
		'suremails'
	),
};
